import { AppSettingCacheMixin } from './AppSettingCacheMixin'

export const AppointmentDefaultsSettingMixin = {
  mixins: [AppSettingCacheMixin],
  computed: {
    settingKey () {
      return 'AppointmentDefaults'
    },
    defaultSettingObject () {
      return {
        petDurationMinutes: 120
      }
    },
    petDurationMinutes () {
      return this.settingObject ? this.settingObject.petDurationMinutes : this.defaultSettingObject.petDurationMinutes
    }
  }
}
